import { useQuery } from "@tanstack/react-query";

import http from "../../../http";
import { GET_PAYMENT_ACCOUNTS } from "../../URL";

interface IPaymentAccount {
  paymentAccountID: string;
  accountName: string;
  paymentAccountTypeCode: string;
}

const getPaymentAccounts = async () => {
  try {  // PR 7831723 
    const response = await http.post<{
      paymentAccountList: IPaymentAccount[];
    }>(GET_PAYMENT_ACCOUNTS);

    return response.data?.paymentAccountList || [];
    
  } 
  // PR 7831723 Start
  catch (error: any) {
    if (error?.response?.status === 400) {
      return [];
    }

    throw error;
  }
  // PR 7831723 End
};

const usePaymentAccounts = () =>
  useQuery<IPaymentAccount[]>({
    queryKey: ["payment-accounts"],
    queryFn: getPaymentAccounts,
    networkMode: "offlineFirst",
    staleTime: Infinity,
  });

export default usePaymentAccounts;
